export enum SelfFixRoutes {
  ApplianceDetails = '/appliance-details',
  SelectedAppliance = '/selected-appliance',
  YourAppliance = '/your-appliance',
  ArticlesTroubleshooting = '/articles/troubleshooting',
  ArticlesHowToFix = '/articles/how-to-fix',
}
